<template>
  <el-dialog :title="isEdit ? '添加病程':'修改病程'" :visible="showAddRecord" width="720px" :close-on-click-modal="false"
    :before-close="handleClose">
    <div class="plan-rights-dialog">
      <el-form ref="recordForm" :model="addRecordForm" :rules="formRules" label-width="140px" size="small">
        <el-form-item label="病程相应时间：" prop="courseTime">
          <!-- <el-input size="medium" v-model.trim="addRecordForm.courseTime" placeholder="请输入病程相应时间" maxlength="30" show-word-limit></el-input> -->
          <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            v-model="addRecordForm.courseTime" style="width:100%"></el-date-picker>
            <!--  :picker-options="pickerOptions0" -->
          <!-- <span v-else>{{addRecordForm.courseTime}}</span> -->
        </el-form-item>
        <!-- 当前病程时间类型 -->
        <el-form-item label="当前病程时间类型：" prop="dateName">
          <el-select ref="selectRef" v-model="addRecordForm.dateName" filterable placeholder="请选择当前病程时间类型"
            style="width:100%">
            <el-option v-for="item in dateNameList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
          <!-- <span v-else>
            {{ addRecordForm.dateName }}
          </span> -->
        </el-form-item>
        <el-form-item label="相应症状：" prop="patientSymptomItems">
          <el-select ref="selectRef" @change="changeSymptom" v-model="patientSymptomItems" multiple filterable remote
            reserve-keyword placeholder="请输入关键词" style="width:100%" value-key="symptomId" clearable
            :remote-method="remoteMethod">
            <el-option v-for="item in symptomOptions" :key="item.symptomId" :label="item.name" :value="item">
            </el-option>
          </el-select>
          <!-- <span v-else class="tag-style">
            <el-tag v-for="(item,index) in addRecordForm.patientSymptomItems" :key="index">{{item.name}}</el-tag>
          </span> -->
        </el-form-item>
        <el-form-item :label="`${item.name}症状程度：`" v-for="(item, key) in symptomGradingList" :key="key">
          <el-select ref="selectRef" v-model="item.levelId" filterable clearable placeholder="请选择当前症状程度"
            :disabled="!item.levelId && !isEdit" style="width:100%">
            <el-option v-for="(it, k) in item.symptomGradingOption" :key="k" :label="it.name"
              :value="it.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="patientSymptomItems.length" label="患者可见：" prop="patientShow">
          <el-radio-group v-model="addRecordForm.patientShow" :disabled="patientSymptomItems.length == 0"
            @change="$forceUpdate()">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <!-- <span v-else>
            {{ addRecordForm.patientShow ? '是' : '否' }}
          </span> -->
        </el-form-item>
        <!-- <el-form-item label="检验检查：" prop="patientSymptomItems">
          <el-select v-model="addRecordForm.checkType" placeholder="请选择">
            <el-option
              v-for="item in checkOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="检验：" prop="inspectionArr">
          <el-select ref="inspectionRef" v-model="inspectionArr" placeholder="请选择检验项目" filterable remote multiple
            reserve-keyword value-key="id" @change="changeInspection" v-elSelectloadMore="loadmoreInspect"
            :remote-method="val => {remoteInspectItemMethod(val);}" style="width:100%" clearable>
            <el-option v-for="(item, index) in inspectionList" :key="index" :label="item.name" :value="item">
            </el-option>
          </el-select>
          <!-- <span v-else class="tag-style">
            <el-tag v-for="(item,index) in addRecordForm.inspectionInfo" :key="index">{{item.name}}</el-tag>
          </span> -->
        </el-form-item>
        <el-form-item label="检查：" prop="checkItemArr">
          <el-select ref="checkRef" v-model="checkItemArr" placeholder="请选择检查项目" filterable multiple remote
            reserve-keyword value-key="id" @change="changeCheckItem" v-elSelectloadMore="loadmoreCheck"
            :remote-method="val => {remoteCheckItemMethod(val);}" clearable style="width:100%">
            <el-option v-for="(item, index) in checkItemList" :key="index" :label="item.name" :value="item">
            </el-option>
          </el-select>
          <!-- <span v-else class="tag-style">
            <el-tag v-for="(item,index) in addRecordForm.checkInfo" :key="index">{{item.name}}</el-tag>
          </span> -->
        </el-form-item>
        <el-form-item label="用药情况：" prop="medicationStatus">
          <el-input type="textarea" maxlength="500" :autosize="{ minRows: 2, maxRows: 20 }" show-word-limit
            placeholder="请输入用药情况" v-model="addRecordForm.medicationStatus"></el-input>
        </el-form-item>
        <el-form-item label="患者情况：" prop="patientInformation">
          <el-input type="textarea" maxlength="500" :autosize="{ minRows: 2, maxRows: 20 }" show-word-limit
            placeholder="请输入患者情况" v-model="addRecordForm.patientInformation"></el-input>
        </el-form-item>
        <el-form-item label="疗管评估：" prop="therapistEvaluation">
          <el-input type="textarea" maxlength="500" :autosize="{ minRows: 2, maxRows: 20 }" show-word-limit
            placeholder="请输入评估情况" v-model="addRecordForm.therapistEvaluation"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancelForm">取 消</el-button>
      <el-button size="small" type="primary" @click="saveRecordForm">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import local from "@/utils/local.js";
import { DEEP_CLONE } from "@/utils/constants";
import {
  saveCourseSymptom,
  pageStandardSymptom,
  updateCourseSymptom,
  pageInspectionInfo,
  pageExamineInfo,
  getDateNameList,
  pageSymptomLevelList,
  getArchiveDiseaseAndTherapyStage,
  updatePatientDateMapping
} from "@/api/addCourseOfDisease";
export default {
  props: {
    planRightsTitle: {
      type: String
    },
    showAddRecord: {
      type: Boolean
    },
    selectRecordItem: {
      type: Object,
      default: () => {}
    },
    // selectRightsRow:{
    //   type: Object,
    //   default: () => {}
    // },
    selectRightsData: {
      type: Array,
      default: () => []
    },
    selectRightsIndex: {
      type: Number
    }
  },
  // directives: {
  //   selectLoadmore: {
  //     bind(el, binding) {
  //       // this.$nextTick(() => {
  //         // debugger
  //         const SELECTWRAP_DOM = el.querySelector(
  //           ".el-select-dropdown .el-select-dropdown__wrap"
  //         );
  //         SELECTWRAP_DOM.addEventListener("scroll", function() {
  //           const condition =
  //             this.scrollHeight - this.scrollTop <= this.clientHeight;
  //           if (condition) {
  //             binding.value();
  //           }
  //         });
  //       // })
  //     }
  //   }
  // },
  data() {
    return {
      isEdit: true,
      checkItemArr: [],
      inspectionArr: [],
      checkItemList: [],
      inspectionList: [],
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      // loading: false,
      symptomOptions: [],
      address: local.get("ADDRESS"),
      VUE_APP_WECHATBASE_URL: "/api/dsicm-contact-platform/feign/file/upload",
      headers: {
        Authorization: localStorage.getItem("Authorization")
      },
      imgPath: process.env.VUE_APP_OSS_URL,
      addRecordForm: {
        courseTime: "",
        patientShow: false,
        medicationStatus: "",
        patientInformation: "",
        checkType: null
      },
      patientSymptomItems: [],
      formRules: {
        courseTime: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ]
        // patientShow:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        // medicationStatus:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        // patientInformation:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        // patientSymptomItems:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }]
      },
      // checkFormData: {
      //   imageUrl: '',
      //   name: '',
      //   examPaperId: '',
      //   id: '',
      //   remark: ''
      // },
      // options: ['不限次','次','次/天','次/周','次/月','次/年']
      inspectPage: {
        current: 1,
        size: 20
      },
      checkPage: {
        current: 1,
        size: 20
      },
      inspectPageNum: 0,
      checkPageNum: 0,
      inspectInput: "",
      checkInput: "",
      dateNameList: [],
      symptomGradingList: [],
      diseaseAndTherapyStage: {} // 获取病种及治疗阶段
    };
  },
  async created() {
    this.getDateNameList();
    console.log("this.selectRecordItem", this.selectRecordItem);
    if (
      (this.selectRecordItem &&
        this.selectRecordItem.operateName === "update") ||
      (this.selectRecordItem && this.selectRecordItem.operateName === "delete")
    ) {
      let { code, data } = await updatePatientDateMapping(this.selectRecordItem.id);
      if (code === 0) {
        this.$emit("getPageCourse", 1);
      }
    }

    if (this.selectRecordItem.courseTime) {
      this.isEdit = false;
      this.addRecordForm = DEEP_CLONE(this.selectRecordItem);
      // this.addRecordForm.patientSymptomVOList
      delete this.addRecordForm.createTime;
      // delete this.addRecordForm.createUserId
      this.patientSymptomItems = this.addRecordForm.patientSymptomVOList.map(
        item => {
          return {
            ...item,
            levelId: item.levelId || ""
          };
        }
      );
      this.symptomOptions = this.patientSymptomItems;
      this.symptomOptions.forEach(item => {
        this.getSymptomLevelList(item);
      });
      this.checkItemList = this.addRecordForm.checkInfo;
      this.inspectionList = this.addRecordForm.inspectionInfo;
      this.inspectionArr = this.addRecordForm.inspectionInfo;
      this.checkItemArr = this.addRecordForm.checkInfo;
      this.addRecordForm.patientShow =
        this.addRecordForm.patientSymptomVOList &&
        this.addRecordForm.patientSymptomVOList.length > 0
          ? this.addRecordForm.patientSymptomVOList[0].patientShow
          : false;
    }
  },
  mounted() {},
  methods: {
    // 获取时间类型列表
    async getDateNameList() {
      let { code, data } = await getDateNameList();
      if (code === 0) {
        this.dateNameList = data;
      }
    },
    loadmoreInspect() {
      this.inspectPage.current++;
      if (this.inspectPage.current > this.inspectPageNum) {
        return;
      }
      this.getInspectionItemList(this.inspectPage.current, this.inspectInput);
      // this.getMergeLeveList();
    },
    loadmoreCheck() {
      this.checkPage.current++;
      if (this.checkPage.current > this.checkPageNum) {
        return;
      }
      this.getExamineInfoList(this.checkPage.current, this.checkInput);
      // this.getMergeLeveList();
    },
    async getInspectionItemList(current, searchCondition) {
      let res = await pageInspectionInfo({
        current: current,
        size: 20,
        searchCondition: searchCondition
      });
      if (res.code == 0) {
        this.inspectionList = this.inspectionList.concat(res.data.records);
        this.inspectPageNum = res.data.pages;
      }
    },
    remoteInspectItemMethod(query) {
      this.inspectionList = [];
      this.inspectPage.current = 1;
      if (query !== "") {
        this.inspectInput = query;
        this.getInspectionItemList(1, query);
      } else {
        this.inspectionList = [];
      }
    },
    remoteCheckItemMethod(query) {
      this.checkItemList = [];
      this.checkPage.current = 1;
      if (query !== "") {
        this.checkInput = query;
        this.getExamineInfoList(1, query);
      } else {
        this.checkItemList = [];
      }
    },
    async getExamineInfoList(current, searchCondition) {
      let res = await pageExamineInfo({
        current: current,
        size: 20,
        condition: searchCondition
      });
      if (res.code == 0) {
        this.checkItemList = this.checkItemList.concat(res.data.records);
        this.checkPageNum = res.data.pages;
      }
    },

    changeSymptom(val) {
      this.$refs.selectRef.query = "";
      this.$emit("change", val);

      if (val.length == 0) {
        this.addRecordForm.patientShow = false;
      }
      this.symptomGradingList = [];
      val.forEach(item => {
        this.getSymptomLevelList({
          ...item,
          symptomId: item.symptomId || item.id
        });
      });
    },
    changeInspection(val) {
      this.$refs.inspectionRef.query = "";
      this.$emit("change", val);
    },
    changeCheckItem(val) {
      this.$refs.checkRef.query = "";
      this.$emit("change", val);
    },
    async remoteMethod(query) {
      if (query !== "") {
        // this.loading = true
        let res = await pageStandardSymptom({
          name: query,
          enabled: true
        });
        if (res.code == 0) {
          this.symptomOptions = res.data.records.map(item => {
            return {
              symptomId: item.id,
              systemCode: item.systemCode,
              name: item.name,
              alias: item.alias,
              hasLevel: item.hasLevel
            };
          });
        }
      } else {
        this.symptomOptions = [];
      }
    },
    handleClose() {
      this.symptomGradingList = [];
      this.$emit("update:showAddRecord", false);
    },
    cancelForm() {
      this.symptomGradingList = [];
      this.$emit("update:showAddRecord", false);
    },
    // async getStandardSymptom() {
    //   let res = await pageStandardSymptom({
    //     name: ''
    //   })
    //   if (res.code == 0) {

    //   }
    // },
    async saveRecordForm() {
      let valRes;
      this.$refs.recordForm.validate(val => {
        valRes = val;
      });
      if (!valRes) {
        return;
      }

      this.patientSymptomItems = this.patientSymptomItems.map((item, key) => {
        return {
          ...item,
          levelId:
            this.symptomGradingList[key] && this.symptomGradingList[key].levelId
              ? this.symptomGradingList[key].levelId
              : ""
        };
      });

      if (this.addRecordForm.id) {
        let res = await updateCourseSymptom({
          ...this.addRecordForm, // addRecordForm.patientSymptomItems
          patientSymptomDTOS: this.patientSymptomItems,
          patientId: this.$store.state.patientInfo.patientId,
          inspectionInfo: this.inspectionArr,
          checkInfo: this.checkItemArr
        });
        if (res.code == 0) {
          this.$message.success("保存成功");
          this.$emit("update:showAddRecord", false);
          this.$emit("getPageCourse", 1);
        }
      } else {
        let symptomDTOS = [];
        this.patientSymptomItems.forEach(v => {
          symptomDTOS.push({
            dataSource: "default",
            symptomId: v.symptomId,
            name: v.name,
            startTime: this.addRecordForm.courseTime,
            levelId: v.levelId,
            patientId: v.patientId
            // patientShow: this.addRecordForm.patientShow
          });
        });
        let checkInfo = [];
        this.checkItemArr.forEach(v => {
          checkInfo.push({
            id: v.id,
            name: v.name
          });
        });
        let inspectionInfo = [];
        this.inspectionArr.forEach(v => {
          inspectionInfo.push({
            id: v.id,
            name: v.name
          });
        });
        let res = await saveCourseSymptom({
          ...this.addRecordForm,
          patientSymptomDTOS: symptomDTOS,
          patientId: this.$store.state.patientInfo.patientId,
          checkInfo: checkInfo,
          inspectionInfo: inspectionInfo
        });
        if (res.code == 0) {
          this.$message.success("保存成功");
          this.$emit("update:showAddRecord", false);
          this.$emit("getPageCourse", 1);
        }
      }
    },
    // 获取当前症状的程度id symptomId: row.symptomId, diseaseId: row.diseaseId, firstTherapyStageId: row.firstTherapyStageId, secondTherapyStageId: row.secondTherapyStageId
    async getSymptomLevelList(row) {
      // isEdit true 添加病程
      if (this.isEdit && !this.diseaseAndTherapyStage.diseaseId) {
        let { code, data } = await getArchiveDiseaseAndTherapyStage({
          patientId: this.$store.state.patientInfo.patientId
        });
        if (code === 0) {
          this.diseaseAndTherapyStage = data;
          pageSymptomLevelList({
            symptomId: row.symptomId,
            diseaseId: data.diseaseId,
            firstTherapyStageId: data.firstTherapyStageId,
            secondTherapyStageId: data.secondTherapyStageId
          }).then(res => {
            let { code, data } = res;
            if (code === 0) {
              let obj = {
                ...row,
                symptomGradingOption: data
              };
              let symptomGradingList = this.symptomGradingList.map(
                item => item.name
              );
              if (symptomGradingList.indexOf(row.name) < 0) {
                this.symptomGradingList.push(obj);
              }
            }
          });
        }
      } else if (this.isEdit && this.diseaseAndTherapyStage.diseaseId) {
        pageSymptomLevelList({
          symptomId: row.symptomId,
          diseaseId: this.diseaseAndTherapyStage.diseaseId,
          firstTherapyStageId: this.diseaseAndTherapyStage.firstTherapyStageId,
          secondTherapyStageId: this.diseaseAndTherapyStage.secondTherapyStageId
        }).then(res => {
          let { code, data } = res;
          if (code === 0) {
            let obj = {
              ...row,
              symptomGradingOption: data
            };
            let symptomGradingList = this.symptomGradingList.map(
              item => item.name
            );
            if (symptomGradingList.indexOf(row.name) < 0) {
              this.symptomGradingList.push(obj);
            }
          }
        });
      } else {
        pageSymptomLevelList({
          symptomId: row.symptomId,
          diseaseId: row.diseaseId,
          firstTherapyStageId: row.firstTherapyStageId,
          secondTherapyStageId: row.secondTherapyStageId
        }).then(res => {
          let { code, data } = res;
          if (code === 0) {
            let obj = {
              ...row,
              symptomGradingOption: data
            };
            let symptomGradingList = this.symptomGradingList.map(
              item => item.name
            );
            if (symptomGradingList.indexOf(row.name) < 0) {
              this.symptomGradingList.push(obj);
            }
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__footer {
  text-align: center;
}
.plan-rights-dialog {
  /deep/.el-input-group__append .el-select {
    width: 88px;
  }
  /deep/.el-input-group__append .el-select .el-input,
  .el-input-group__append .el-select .el-input--suffix {
    width: 88px;
  }
}
.tag-style {
  .el-tag {
    margin-right: 10px;
  }
}
/deep/.el-textarea__inner {
  padding-bottom: 25px;
  min-height: auto !important;
}
/deep/ .el-textarea .el-input__count {
  height: 20px;
  line-height: 20px;
  background: none;
  right: 18px;
}
</style>
<style lang="less">
.message-del-confirm {
  .el-button--primary {
    background-color: #1a7bfc;
  }
}
.son-upload-tips {
  display: block;
  height: 60px;
  padding-top: 30px;
  color: #999999;
}
</style>
